export default "__VITE_ASSET__BrOjnoV8__"